import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales-completions', storeModule.createStoreModule('sales-completions'))
